module.exports = __webpack_public_path__ + "img/91017.b8ebb9ff.svg";